import { Database } from '@vuex-orm/core';
import * as storeModules from '../store/modules/';
import * as ormModels from './models/';

const database = new Database();

database.register(ormModels.CurrentUser, storeModules.CurrentUser);
database.register(ormModels.Trial);
database.register(ormModels.Booking);
database.register(ormModels.Projects);
database.register(ormModels.Products);
database.register(ormModels.Plants);
database.register(ormModels.Teams);
database.register(ormModels.Technology);
database.register(ormModels.Brands);
database.register(ormModels.TrialSets);
database.register(ormModels.Alert);
database.register(ormModels.Subproducts);
database.register(ormModels.Process);
database.register(ormModels.ProcessStages);
database.register(ormModels.ProcessSteps);
database.register(ormModels.IngredientGroups);
database.register(ormModels.FermentGroups);
database.register(ormModels.RecipeModule);
database.register(ormModels.Recipes);
database.register(ormModels.MixingModule);
database.register(ormModels.Mixins);
database.register(ormModels.Premixes);
database.register(ormModels.Total);
database.register(ormModels.MixRecipes);
database.register(ormModels.MixinComponents);
database.register(ormModels.CustomIngredients);
database.register(ormModels.Packagings);
database.register(ormModels.SamplingModule);
database.register(ormModels.Sampling);
database.register(ormModels.Comments);
database.register(ormModels.AnalysisComponents);
database.register(ormModels.AnalysisObject);
database.register(ormModels.AnalysisProducts);
database.register(ormModels.Analysis);
database.register(ormModels.AnalysisClasses);
database.register(ormModels.Laboratories);
database.register(ormModels.SuggestUsers);
database.register(ormModels.ComponentSets);
database.register(ormModels.TrialHistory);
database.register(ormModels.Documents);

export default database;
